const RENTALS_IMAGES = {
  //getPropertyCMGalleries
  RENTALS_PROPERTY_CM_GALLERIES: 'RENTALS_PROPERTY_CM_GALLERIES',
  //getPropertyGalleries
  RENTALS_PROPERTY_GALLERIES: 'RENTALS_PROPERTY_GALLERIES',
  //getPropertyCMPartners
  RENTALS_PROPERTY_CM_PARTNERS: 'RENTALS_PROPERTY_CM_PARTNERS',
};

export default RENTALS_IMAGES;
